<template>
  <div class="award">
    <div class="contentBox" v-if="isShowInfo">
      <div class="title">《{{ ruleForm.AwardName }}》补填信息</div>
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业工商名称(中文)" prop="CompanyNameCN">
              <el-input v-model="ruleForm.CompanyNameCN" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人手机" prop="PhoneNumber">
              <el-input
                v-model="ruleForm.PhoneNumber"
                placeholder="联系人手机"
                maxlength="11"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              prop="Content"
              label="补填信息"
              :rules="[
                { required: true, message: '请输入补填信息', trigger: 'blur' },
              ]"
            >
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 8 }"
                v-model="ruleForm.Content"
                placeholder="没有补充信息，请填“无”"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="AwardAttachments" label="上传附件">
              <div class="fileFlex">
                <!-- <el-upload
                  :action="UploadApi"
                  :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 3)
                    }
                  "
                  :on-success="
                    (response, file, fileList) => {
                      return handleSuccess(response, file, fileList, 3)
                    }
                  "
                  :limit="5"
                  :on-error="uploadError"
                  :on-remove="
                    (file, fileList) => {
                      return handleRemove(file, fileList, 3)
                    }
                  "
                  :file-list="ruleForm.AwardAttachments"
                >
                  <el-button size="small" class="fontF" type="primary"
                    >选择附件</el-button
                  >
                  <span class="spanRemark">上传文件数量提示：如文件数量较多可压缩后上传，并以【企业名称+申报奖项命名】，请勿上传视频文件。每个上传文件大小不超过1G。</span>
                </el-upload> -->
                <UploadPan
                  ref="upload2"
                  v-model="fileList2"
                  :form="form"
                  class="editor-upload-btn"
                  :model="model"
                  @on-close="handleCloseUpload2"
                  @on-update="handleOnUpdate2"
                  :accept="accept2"
                  color="#1890ff"
                />
                <span class="spanRemark"
                  >上传文件数量提示：如文件数量较多可压缩后上传，并以【企业名称+申报奖项命名】，请勿上传视频文件。每个上传文件大小不超过1G。</span
                >
              </div>
              <ul v-show="ruleForm.AwardAttachments" class="listFile">
                <li
                  v-for="(fileItem, index) in ruleForm.AwardAttachments"
                  :key="index"
                >
                  <div class="div1">{{ fileItem.name }}</div>
                  <div class="div2" @click="removeItem(fileItem.url)">删除</div>
                </li>
              </ul>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item class="btnClass">
              <el-button
                @click="clickSubmit('ruleForm')"
                type="primary"
                :disabled="ruleForm.Status !== 3"
                >提交</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="noPage" v-else>找不到页面</div>
    <el-dialog
      title="资料提交提示"
      :visible.sync="dialogVisible"
      width="50%"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="sussDiv">
        <div class="sussOne">
          <img src="../../assets//successs.svg" alt="" /> 资料提交成功
        </div>
        <div class="sussTwo">您的补填资料已收到，进入资料审核阶段。</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAwardApplicationInfoByID,
  submitAwardReplenish,
  getAwardApplicationInfoByEncryptReplenishId,
} from '../../api/api'
import UploadPan from '@/components/Upload/index'
export default {
  data() {
    return {
      UploadApi: `${process.env.VUE_APP_BASE_API}/api/AwardApplication/upload`,
      isShowInfo: false, // 是否显示页面
      ruleForm: {
        AwardName: '', // 标题名称
        Status: 0,
        CompanyNameCN: '',
        PhoneNumber: '',
        ApplyAwardTypeNames: [],
        EncryptId: '',
        Content: '',
        AwardAttachments: [],
      },
      disabled: false, // 是否禁用  即点击之后一段时间内无法再点击
      dialogVisible: false, // 提交后的提示

      fileList2: [],
      model: `hrmarket/${new Date().getFullYear()}${new Date().getMonth() + 1}`,
      form: {
        bucket: 'video-hroot',
        region: 'oss-cn-hangzhou',
      },
      accept2: '*',
    }
  },
  components: {
    UploadPan,
  },
  methods: {
    // 提交
    clickSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitAwardReplenish(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.dialogVisible = true
              // this.$router.push('/success')
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning',
              })
            }
          })
        } else {
          return false
        }
      })
    },

    handleCloseUpload2() {
      this.fileList2 = []
    },
    handleOnUpdate2(obj) {
      const url = `https://${this.form.bucket}.${this.form.region}.aliyuncs.com/${obj.OssKey}`
      let attachment = {
        url: url,
        name: obj.ResTitle,
        ContentType: obj.ContentType,
        Type: 3,
      }
      this.ruleForm.AwardAttachments.push(attachment)
    },
    // 删除附件
    removeItem(url) {
      this.ruleForm.AwardAttachments = this.ruleForm.AwardAttachments.filter(
        (item) => item.url != url
      )
      this.$forceUpdate()
    },

    // uploadError(err, file, fileList) {
    //   this.$message.error('上传文件失败！')
    // },

    // handleBeforeUpload(file, type) {
    //   console.log(file)
    //   console.log(type)
    //   var regEn = /[`~!#$%^&*+<>?:"{},\/;'[\]]/im,
    //     regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
    //   if (regEn.test(file.name) || regCn.test(file.name)) {
    //     this.$message({
    //       type: 'warning',
    //       message: '文件名称不能包含特殊字符,()_除外',
    //     })
    //     return false
    //   }
    //   const typeArry = ['.mp4', '.avi', '.flv', '.mpeg', '.mov', '.mp3', '.wav', '.m4a', '.exe'];
    //   const fileType = file.name.substring(file.name.lastIndexOf('.'));
    //   const isVideo = typeArry.indexOf(fileType) > -1;
    //   if (isVideo) {
    //     this.$message({
    //       type: 'warning',
    //       message: '不能上传此类型文件！',
    //     })
    //     return false
    //   }
    //   if(file.size>=1073741824){
    //     this.$message({
    //       type: 'warning',
    //       message: '文件大小超出限制，请上传小于1G的文件！',
    //     })
    //     return false
    //   }

    //   var some = this.ruleForm.AwardAttachments.some(
    //     (a) => (a.name == file.name) & (a.Type == type)
    //   )
    //   if (some) {
    //     this.$message({
    //       type: 'warning',
    //       message: '上传文件名称不能相同',
    //     })
    //     return false
    //   }
    //   return true
    // },
    // handleSuccess(response, file, fileList, type) {
    //   let attachment = {
    //     url: response.response,
    //     name: file.raw.name,
    //     ContentType: file.raw.type,
    //     Type: type,
    //   }
    //   this.ruleForm.AwardAttachments.push(attachment)
    // },
    // handleRemove(file, fileList, type) {
    //   if (type == 3) {
    //     this.ruleForm.AwardAttachments = this.ruleForm.AwardAttachments.filter(
    //       (a) => (a.name != file.name) & (a.Type == type)
    //     )
    //   }
    // },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.getAwardApplicationInfoByEncryptReplenishId()
    },

    // 根据ID查找奖项名称
    getAwardApplicationInfoByEncryptReplenishId() {
      getAwardApplicationInfoByEncryptReplenishId(this.$route.params.id).then(
        (res) => {
          if (res.data.success) {
            this.ruleForm = res.data.response
            this.isShowInfo = true
            this.ruleForm.EncryptId = this.$route.params.id
            this.$set(this.ruleForm, 'Content', '')
            this.ruleForm.AwardAttachments = []

            if (res.data.response.Status !== 3) {
              this.$message({
                type: 'warning',
                message: '当前页面不可操作，请勿继续操作！，',
              })
            }
          } else {
            this.isShowInfo = false
          }
        }
      )
    },

    // 添加判断方法
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      console.log(flag)
      return flag
    },
  },
  mounted() {
    // 根据ID查找奖项名称
    this.getAwardApplicationInfoByEncryptReplenishId()

    if (this.isMobile()) {
      this.$message({
        message: '请复制链接，在电脑端进行操作！',
        type: 'warning',
        duration: 10000,
      })
    }
  },
}
</script>

<style scoped>
.el-select {
  width: 100%;
}
.award {
  width: 100%;
  height: 100vh;
  position: relative;
  background: rgba(200, 200, 200, 0.1);
  overflow: auto;
}
.contentBox {
  position: relative;
  border: 0px solid red;
  width: 1000px;
  display: block;
  margin: 0 auto;
  padding: 30px 30px;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(65, 67, 70, 0.1);
}
.title {
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  font-weight: bold;
  padding: 0 0;
  margin: 0 0 50px;
}
.codeBox {
  display: flex;
  flex-wrap: nowrap;
}
.divCode {
  width: 50%;
}
.divCode:first-child {
  margin-right: 20px;
}
.fileFlex {
  display: flex;
  align-items: center;
}
.divLogos a {
  margin-right: 20px;
}
.btnClass {
  text-align: center;
  color: #606266;
}
.spanRemark {
  color: #606266;
  margin-left: 20px;
}

.noPage {
  text-align: center;
  font-size: 30px;
  line-height: 40px;
  padding: 100px;
}
.sussDiv {
  text-align: center;
}
.sussDiv img {
  width: 36px;
  display: block;
  margin-right: 20px;
}
.sussOne {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  line-height: 30px;
}
.sussTwo {
  margin-top: 30px;
  font-size: 16px;
  line-height: 30px;
}
.listFile {
  color: #555555;
  margin: 20px 0 0;
  padding: 0 0;
}
.listFile li {
  list-style-type: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 0 10px;
}
.listFile li:hover {
  background-color: #f5f7fa;
}
.listFile .div1 {
  flex: 1;
}
.listFile .div2 {
  width: 30px;
  cursor: pointer;
}
</style>
